// src/components/dashboard/AccountUnderReview.jsx
import React, { useState, useEffect } from 'react';

const AccountUnderReview = ({ user }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (user) {
      setUserData(user);
    }
  }, [user]);

  if (!userData) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 max-w-md mx-auto">
      <div className="text-center">
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg 
            className="w-8 h-8 text-orange-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
            />
          </svg>
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Account Under Review
        </h3>
        
        <p className="text-gray-600 mb-3">
          Your request to create a wallet account for:
        </p>
        
        <div className="bg-white border border-gray-200 rounded-md py-3 px-4 mb-4">
          <span className="font-semibold text-gray-900 text-lg">
            {userData.requested_name}
          </span>
        </div>
        
        <p className="text-gray-600 mb-4">
          is currently being reviewed. You will receive a response via email within 48 hours.
        </p>
        
        <div className="text-sm text-gray-500 mt-4">
          <p>For urgent inquiries, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default AccountUnderReview;